$(function () {	
  // チャットの画面ではバッジを表示しない
  if (window.location.pathname.match('/chat')) return;

  var INTERVAL = 15 * 1000;   // 更新間隔 [msec]	
  var CHAT_UNREAD_COUNT_SELECTOR = '.js-chat-unread-badge';         // チャット未読件数バッジ	
  var $chatUnreadCountList = $(CHAT_UNREAD_COUNT_SELECTOR);	
  var timerId = null;   // ループタイマーID	

  /**	
   * タイマー解除	
   */	
  function clearTimer() {	
    clearTimeout(timerId);	
    timerId = null;	
  }	

  /**	
   * バッジ情報の取得・更新	
   */	
  function updateBadge () {	
    // バッジ情報取得	
    $.get('/api/v1/chat_messages/unread_count').done(function (data) {	
      // バッジ更新	
      var unread_count = parseInt(data['unread_count']);	
      updateChatBadge(unread_count);	
    });	

    // タイマーリセット	
    if (timerId) {	
      clearTimer();	
    }	

    // ループ	
    timerId = setTimeout(function () {	
      clearTimer();	
      updateBadge();	
    }, INTERVAL);	
  }	

  /**	
   * チャット未読件数バッジを更新	
   * @param {Number}  count 未読件数	
   */	
  function updateChatBadge(count) {	
    $.each($chatUnreadCountList, function () {	
      var $this = $(this);	
      var $anchor = $this.find('a');	
      var $badge = $anchor.find('.unread-count');	
      count = Math.min(count, 999); // 表示の上限は999件	
      if ($badge.length) {	
        // バッジが表示されており、かつ未読があるときは未読件数を更新	
        if (count > 0) {	
          $badge.text(count);	
        }	
        // バッジが表示されており、かつ未読がないときはバッジを削除	
        else {	
          $badge.remove();	
        }	
      }	
      // バッジが表示されておらず、かつ未読があるときはバッジを作成	
      else {	
        if (count > 0) {	
          $('<span>').addClass('unread-count unread-count--chat').text(count).appendTo($anchor);	
        }	
      }	
    });	
  }	

  // DOMContentLoaded	
  $(function () {	
    if ($chatUnreadCountList.length) {	
      updateBadge();	
    }	
  });	
}.call(this)); 
